import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import useAdminGuard from "../hooks/useAdminGuard";
import {Link} from "react-router-dom";

export default function AdminInquiriesPage() {
  useAdminGuard(); // 관리자만 접근
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState({}); // 문의별 답변 입력값 저장

  const loadInquiries = async () => {
    setLoading(true);
    const res = await fetchWithAuth("/inquiries");
    if (res.ok) {
      const data = await res.json();
      setInquiries(data);
    }
    setLoading(false);
  };

  const handleAnswerSubmit = async (id) => {
    const answer = answers[id];
    if (!answer || !answer.trim()) {
      alert("답변 내용을 입력하세요.");
      return;
    }
    const res = await fetchWithAuth(`/inquiries/${id}/answer`, {
      method: "POST",
      body: JSON.stringify({ answer }),
    });
    if (res.ok) {
      alert("답변이 등록되었습니다.");
      setAnswers((prev) => ({ ...prev, [id]: "" }));
      loadInquiries();
    } else {
      alert("답변 등록 실패");
    }
  };

  useEffect(() => {
    loadInquiries();
  }, []);

  return (
    <div className="p-6 text-white bg-gray-900 min-h-screen">
      <Link
        to="/admin"
        className="px-4 py-2 text-sm font-semibold bg-purple-500 text-white rounded-full"
      >
        관리자페이지
      </Link>
      <div className="max-w-4xl mx-auto p-4 text-white">
      <h1 className="text-2xl font-bold mb-4">관리자 문의 목록</h1>
      {loading ? (
        <div>로딩 중...</div>
      ) : inquiries.length === 0 ? (
        <p>등록된 문의가 없습니다.</p>
      ) : (
        inquiries.map((inq) => (
          <div key={inq.id} className="border-b border-gray-700 py-4">
            <div className="font-bold text-lg">{inq.title}</div>
            <div>{inq.content}</div>
            <div className="text-sm text-gray-400">
              {inq.user_email} ({inq.user_nickname})
            </div>
            {inq.answer ? (
              <div className="mt-2 text-green-400">[답변] {inq.answer}</div>
            ) : (
              <div className="mt-2">
                <textarea
                  value={answers[inq.id] || ""}
                  onChange={(e) =>
                    setAnswers((prev) => ({ ...prev, [inq.id]: e.target.value }))
                  }
                  className="w-full p-2 text-black rounded"
                />
                <button
                  onClick={() => handleAnswerSubmit(inq.id)}
                  className="bg-blue-500 px-3 py-1 rounded mt-2 hover:bg-blue-600"
                >
                  답변 등록
                </button>
              </div>
            )}
            <div className="text-xs text-gray-400">
              {new Date(inq.created_at).toLocaleString()}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
  );
}
